// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"b3fc4202","263":"e25407e4","666":"3a5bbda6","787":"a26d641c","801":"6a73708b"}[chunkId] + ".chunk.js";
};